const STORAGE_KEY = 'accessibility-settings'

const defaultSettings = {
	fontSize: 'normal',
	lineHeight: 'normal',
	letterSpacing: 'normal',
	contrast: 'standard',
	boldText: false,
	grayscale: false,
	hideImages: false,
	underlineLinks: false,
}

export const useAccessibilitySettings = () => {
	const settings = useState(STORAGE_KEY, () => ({
		...defaultSettings
	}))

	const loadSettings = () => {
		if(!process.client)
			return

		const storedSettings = localStorage.getItem(STORAGE_KEY)
		if (storedSettings) {
			settings.value ={
				...defaultSettings,
				...JSON.parse(storedSettings)
			}
		} else {
    		settings.value = { ...defaultSettings }
  		}
		applySettings(settings.value)
	}

	const resetSettings = () => {
  		if(!process.client)
			return

		settings.value = { ...defaultSettings }
		applySettings(settings.value)
		localStorage.removeItem(STORAGE_KEY)
	}

	const applySettings = (value:any) => {
		if(!process.client)
			return

		const root = document.documentElement
		root.classList.toggle('accessibility-bold', value.boldText)
		root.classList.toggle('accessibility-grayscale', value.grayscale)
		root.classList.toggle('accessibility-hide-images', value.hideImages)
		root.classList.toggle('accessibility-underline-links', value.underlineLinks)

		root.dataset.fontSize = value.fontSize
		root.dataset.contrast = value.contrast
		root.dataset.lineHeight = value.lineHeight
		root.dataset.letterSpacing = value.letterSpacing
	}

	const saveSettings = () => {
		if(!process.client)
			return
		localStorage.setItem(STORAGE_KEY, JSON.stringify(settings.value))
	}

	watch(settings, (value) => {
		applySettings(value)
	}, {deep: true})

	return {
		settings,
		applySettings,
		loadSettings,
		saveSettings,
		resetSettings
	}
}
